export default "__VITE_ASSET__CkosdYUp__"